import { DEFAULT_GROOVES } from './leafGrooves.js';

export const COTTAGE_PATTERNS = [['vertical', 'Vertical panels'], ['chevron', 'Chevron panels']];

// Cottage is a natural-pine assembly, including the frame and window trims.
// Studio renders pass a custom paint colour, so colour_untreated alone cannot
// identify its finish. Other timber families still follow the selected paint.
export const usesPineTrim = (family, colour) => family === 'COTTAGE'
  || (colour === 'colour_untreated' && ['MERANTI', '18_DEG'].includes(family));

// Studio paint is a HEX value, so keep the untreated choice explicitly in the
// workspace/render snapshot. It is not part of a reusable window/groove design.
export const studioColourOption = (family, finish) => family === 'COTTAGE'
  || (finish === 'untreated' && ['MERANTI', '18_DEG'].includes(family))
  ? 'colour_untreated' : 'colour_custom_ral';

export function readCottagePattern(value = 'chevron') {
  if (!COTTAGE_PATTERNS.some(([id]) => id === value)) throw new Error('Choose vertical or chevron Cottage panels.');
  return value;
}

// Cottage panel joints are a surface finish, never Boolean cuts. Meranti uses
// real cuts; an explicit count of zero remains a valid smooth custom design.
export function leafGroovesForFamily(family, grooves) {
  if (family === 'COTTAGE') return { ...DEFAULT_GROOVES };
  return grooves ?? (family === 'MERANTI'
    ? { ...DEFAULT_GROOVES, count: 6, direction: 'vertical', side: 'both' }
    : { ...DEFAULT_GROOVES });
}

// The existing vertical joint maps are shared assets, despite their historic
// merantilines filenames. Only Cottage uses them now. Keep normal/AO paired
// on the same UV channel, independently of the wood grain's scale.
export function timberLeafSurface(family, cottagePattern) {
  if (family === 'COTTAGE') return readCottagePattern(cottagePattern) === 'vertical'
    ? { diffuse: 'pine', normal: 'verticalNormal', ao: 'verticalOcclusion', strength: 1.5,
      uvScale: 1, reliefScale: 0.5 / 0.828, reliefChannel: 'uv1' }
    : { diffuse: 'cottageDiffuse', normal: 'cottageNormal', ao: 'cottageOcclusion', strength: -3,
      uvScale: 0.5 / 0.828, reliefScale: 0.5 / 0.828, reliefChannel: 'uv' };
  if (family === 'MERANTI') return { diffuse: 'meranti', normal: null, ao: null, strength: 1,
    uvScale: 0.5 / 1.128, reliefScale: null, reliefChannel: null };
  return null;
}
